<template>
  <b-modal
    id="document-preview-modal"
    :title="previewFile.name"
    size="xl"
    hide-footer
  >
    <div v-if="isLoading" class="preview-iframe">
      <LmComponentLoading />
    </div>
    <iframe
      v-else
      :src="previewFile.src"
      frameborder="0"
      width="100%"
      class="preview-iframe"
    ></iframe>
  </b-modal>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    dataToRender: {
      type: Object,
      required: true
    },
    documentTypeId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      previewFile: {
        name: '',
        src: ''
      }
    }
  },
  methods: {
    async onPreview () {
      try {
        this.isLoading = true
        await this.$bvModal.show('document-preview-modal')
        const pdfLocation = await commonsApi.axiosPostWrapper('/documents/preview', {
          id: this.$route.params.id,
          documentTypeId: this.documentTypeId,
          ...this.dataToRender
        })

        this.previewFile = pdfLocation.data
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.preview-iframe
  min-height: 80vh
</style>
